import { useEffect, useRef, useState } from 'react';
import { Box, Image } from '@chakra-ui/react';

import { UploadIcon } from 'Asset/icon';

import styles from './styles.module.css';

const InputUploadFile = ({ onChange, accept = 'image/*', width = '72px', height = '72px', isDisabled, initialPreview = null, 'data-testid': testId }) => {
  const inputRef = useRef(null);
  const [preview, setPreview] = useState(initialPreview);

  useEffect(() => {
    setPreview(initialPreview);
  }, [initialPreview]);

  const isImage = accept.startsWith('image');

  const handleClick = () => {
    if (!isDisabled) inputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (isImage) setPreview(URL.createObjectURL(file));
    onChange?.(file);
  };

  return (
    <Box
      className={`${styles['upload-file__box']} ${isDisabled ? styles['upload-file__box--disabled'] : ''}`}
      onClick={handleClick}
      width={width}
      minWidth={width}
      height={height}
    >
      <input ref={inputRef} type="file" accept={accept} onChange={handleChange} style={{ display: 'none' }} data-testid={testId} />
      {isImage && preview ? (
        <Image src={preview} alt="uploaded" width="100%" height="100%" objectFit="cover" borderRadius="4px" />
      ) : (
        <UploadIcon size="16px" color="var(--color-neutral40)" />
      )}
    </Box>
  );
};

export default InputUploadFile;
